import {FeatureGateTier, ProjectFeatureFlag} from 'common/report/constants';
import {CurrentProject} from 'common/report/model-resources/projects';

export function isMetricUnitsEnabled(project: CurrentProject) {
  const hasFeatureFlag = project?.hasFeatureFlag(ProjectFeatureFlag.MetricUnits) || false;
  const isEnterprise = project?.featureGateTier === FeatureGateTier.Enterprise;

  return hasFeatureFlag && isEnterprise;
}
